export default "__VITE_ASSET__CIvYE3hA__"